var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.6665 0.5C4.2505 0.5 0.666504 4.084 0.666504 8.5C0.666504 12.916 4.2505 16.5 8.6665 16.5C13.0825 16.5 16.6665 12.916 16.6665 8.5C16.6665 4.084 13.0825 0.5 8.6665 0.5ZM9.4665 12.5H7.8665V7.7H9.4665V12.5ZM9.4665 6.1H7.8665V4.5H9.4665V6.1Z",
    fill: "#006293"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9704bc7e392966f2bf1e68b182cedcce.svg";
export { ForwardRef as ReactComponent };